import React from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  CardMedia,
  Chip,
  Divider,
  Grid,
  Paper
} from "@mui/material";
import DOMPurify from 'dompurify';
import { Impact } from "../types/impact";

interface Props {
  impact: Impact;
}

const ImpactDetail: React.FC<Props> = ({ impact }) => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        {impact.title}
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Card>
            {impact.image_url && (
              <CardMedia
                component="img"
                height="300"
                image={impact.image_url}
                alt={impact.title}
                sx={{ objectFit: 'cover' }}
              />
            )}
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Impact Value
              </Typography>
              <Chip 
                label={impact.value} 
                color="primary" 
                size="medium"
                sx={{ fontSize: '1.1rem', fontWeight: 'bold' }}
              />
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3, height: '100%' }}>
            <Typography variant="h6" gutterBottom>
              Description
            </Typography>
            <Box 
              sx={{ 
                '& ul': { 
                  paddingLeft: 2,
                  margin: 0,
                  '& li': {
                    marginBottom: 0.5
                  }
                }
              }}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(impact.description || 'No description provided')
              }}
            />

            <Divider sx={{ my: 2 }} />

            <Typography variant="h6" gutterBottom>
              Details
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Box>
                <Typography variant="subtitle2" color="text.secondary">
                  Created At
                </Typography>
                <Typography variant="body2">
                  {new Date(impact.created_at).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                  })}
                </Typography>
              </Box>
              
              <Box>
                <Typography variant="subtitle2" color="text.secondary">
                  Last Updated
                </Typography>
                <Typography variant="body2">
                  {new Date(impact.updated_at).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                  })}
                </Typography>
              </Box>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ImpactDetail;
